import { render, staticRenderFns } from "./CustomerInput.vue?vue&type=template&id=4878b8d3&scoped=true&"
import script from "./CustomerInput.vue?vue&type=script&lang=js&"
export * from "./CustomerInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4878b8d3",
  null
  
)

export default component.exports